// Company Details - Centralized data source for all company information
export const companyDetails = {
  // Basic Company Information
  name: "MASTISHORTS TECHNOLOGY PRIVATE LIMITED",
  shortName: "MastiShorts",
  
  // Contact Information
  email: "mastiiindiaofficial@gmail.com",
  phone: "+91 9883684763",
  phoneDisplay: "+91 9883684763",
  phoneLink: "tel:+919883684763",
  
  // Address Information
  address: {
    full: "C/O MAHADEV MONDAL AKUI, P.O : AKUI, P.S: INDUS, BANKURA : 722201 WESTBENGAL",
    state: "West Bengal",
    country: "India",
    pincode: "722201"
  },
  
  // Operating Hours
  operatingHours: {
    weekdays: "Monday to Friday: 9:00 AM - 6:00 PM (IST)",
    saturday: "Saturday: 10:00 AM - 2:00 PM (IST)",
    sunday: "Sunday: Closed",
    customerCare: "Customer care available 24×7"
  },
  
  // Social Media Links
  socialMedia: {
    facebook: "#",
    instagram: "#",
    twitter: "#",
    linkedin: "#"
  },
  
  // Brand Assets
  logo: {
    src: "/img/app_logo.png",
    alt: "Masti Shorts Logo"
  },
  
  // Website Information
  website: {
    domain: "mastishorts.com",
    description: "The ultimate destination for live streaming and short video content"
  },
  
  // Support Information
  support: {
    email: "mastiiindiaofficial@gmail.com",
    phone: "+91 6291992656",
    description: "For technical assistance or issues related to your subscription or purchases"
  },
  
  // Legal Information
  legal: {
    lastUpdated: "July 29, 2025",
    copyrightYear: "2025",
    copyrightText: "MastiShorts, All rights reserved"
  },
  
  // Services Information
  services: [
    "Content Creation",
    "Video Editing",
    "Social Media Marketing",
    "Brand Promotion",
    "Digital Strategy"
  ],
  
  // Statistics
  stats: {
    users: "150K+",
    videos: "50K+",
    rating: "4.8/5"
  },
  
  // Pricing Information - Coin Packages
  pricing: [
    {
      id: 1,
      price: 17,
      coins: 150,
      currency: "INR",
      popular: false,
      category: "Starter"
    },
    {
      id: 2,
      price: 85,
      coins: 750,
      currency: "INR",
      popular: false,
      category: "Basic"
    },
    {
      id: 3,
      price: 255,
      coins: 2250,
      currency: "INR",
      popular: true,
      category: "Popular"
    },
    {
      id: 4,
      price: 424,
      coins: 3750,
      currency: "INR",
      popular: false,
      category: "Premium"
    },
    {
      id: 5,
      price: 848,
      coins: 7550,
      currency: "INR",
      popular: false,
      category: "Professional"
    },
    {
      id: 6,
      price: 1695,
      coins: 15120,
      currency: "INR",
      popular: false,
      category: "Enterprise"
    }
  ],

  // Testimonials Information
  testimonials: [
    {
      id: 1,
      name: "Dhanesh Kushwaha",
      date: "23 August 2023",
      rating: 5,
      review: "Masti app is a great source of earning if you are a content creator. I love this app for entertainment purposes. It is accessible for everyone. Its easy to use with very cool features, filters, editors and much more stuff with which you can make your video more amazing. Live chat ..gifts",
      icon: "fas fa-user-circle"
    },
    {
      id: 2,
      name: "Er. M.S.Thakur",
      date: "13 July 2023",
      rating: 5,
      review: "Very good application has come after a long time, it is a lot of fun to come live on this application and do gifting...🤟",
      icon: "fas fa-user-tie"
    },
    {
      id: 3,
      name: "Sabuj Roy",
      date: "12 July 2023",
      rating: 5,
      review: "Mastishorts app is a great source of earning if you are a content creator😊. I love this app for entertainment purposes 🥰🥰.It is accessible for everyone. Its easy to use with very cool features, filters, editors and much more stuff with which you can make your video more amazing.Live chat ..gifts ..5star 😘☺️☺️",
      icon: "fas fa-user"
    }
  ],

  // Cloud Storage Information
  cloudStorage: {
    aws: {
      name: "Amazon Web Services",
      headquarters: "410 Terry Ave. N Seattle, Washington 98109, USA",
      website: "https://aws.amazon.com",
      privacyPolicy: "https://aws.amazon.com/privacy/?nc1=f_pr"
    },
    gcp: {
      name: "Google Cloud Platform",
      provider: "Google LLC",
      headquarters: "1101 S Flower St, Burbank, California 91502, USA",
      website: "https://cloud.google.com",
      privacyPolicy: "https://policies.google.com/privacy"
    }
  }
};

// Helper functions for common operations
export const getCompanyName = () => companyDetails.name;
export const getShortName = () => companyDetails.shortName;
export const getEmail = () => companyDetails.email;
export const getPhone = () => companyDetails.phone;
export const getPhoneLink = () => companyDetails.phoneLink;
export const getAddress = () => companyDetails.address.full;
export const getLogo = () => companyDetails.logo;
export const getSocialMedia = () => companyDetails.socialMedia;
export const getOperatingHours = () => companyDetails.operatingHours;
export const getServices = () => companyDetails.services;
export const getStats = () => companyDetails.stats;
export const getSupport = () => companyDetails.support;
export const getLegalInfo = () => companyDetails.legal;
export const getCloudStorage = () => companyDetails.cloudStorage;
export const getPricing = () => companyDetails.pricing;
export const getTestimonials = () => companyDetails.testimonials;
